const base_url = 
  window.location.hostname === "localhost"
    ? "http://localhost:5000/apis" // Local URL
    : "https://shawlhaus.com/api/apis"; // Production URL

export default base_url;
